module.exports = __webpack_public_path__ + "media/auto_data/check-off-439721f5.png";